import get from 'lodash/get'

export const getFileUpload = (state, id) => get(state, ['vegetation', 'fileUpload', id])





// WEBPACK FOOTER //
// ./src/modules/vegetation/selectors/fileUpload.js